import React from 'react';
import PropTypes from 'prop-types';

import PlusIcon from 'components/icons/PlusIcon';

import { Box, Typography, Button } from '@mui/material';
import LinkIcon from 'components/icons/LinkIcon';

const Placeholder = ({ onClick }) => {
  return (
    <Box sx={{ 
      height: "100%", 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      p: 4,
      color: "text.secondary"
    }}>
      <Box 
        sx={{ 
          width: 60, 
          height: 60, 
          borderRadius: "50%", 
          bgcolor: "rgba(0,0,0,0.05)", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
          mb: 2 
        }}
      >
        <LinkIcon />
      </Box>
      <Typography variant="body2" sx={{ mb: 1 }}>No social links added yet</Typography>
      <Typography variant="caption" sx={{ mb: 2, textAlign: "center" }}>
        Create your first social link to show on your link page
      </Typography>
      <Button
        variant="contained"
        size="small"
        startIcon={
          <PlusIcon />
        }
        sx={{ 
          borderRadius: 1,
          textTransform: "none",
          fontWeight: "medium",
          px: 2
        }}
        onClick={onClick}
      >
        Add First Link
      </Button>
    </Box>
  );
};

Placeholder.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Placeholder;
